import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Text from '../basic/Text';

function NumberFormat({
  number, currency, decimals, ...rest
}) {
  const floatNumber = parseFloat(number);
  const intNumber = floatNumber.toFixed(0);
  const numberLength = intNumber.toString().length;
  const minusSignCorrection = (floatNumber < 0) ? -1 : 0;
  let decimalsParsed = parseInt(decimals, 10);
  if(isNaN(decimalsParsed)) decimalsParsed = 0;
  const formatedNumber = floatNumber.toPrecision(numberLength + minusSignCorrection + decimalsParsed);

  return (
    <Text {...rest}>
      {formatedNumber}
      {currency}
    </Text>
  );
}

const mapStateToProps = ({ auth: { user } }) => {
  const { currency, decimals } = user || { currency: '', decimals: 2 };
  return {
    currency,
    decimals,
  };
};

NumberFormat.propTypes = {
  currency: PropTypes.string.isRequired,
  decimals: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  number: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
NumberFormat.defaultProps = {
  number: 0,
};
export default connect(mapStateToProps, null)(NumberFormat);
